import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface QuickWinCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  severity?: "high" | "medium" | "low" | "good";
  id?: string;
}

export const QuickWinCard: React.FC<QuickWinCardProps> = ({
  title,
  description,
  icon,
  children,
  severity = "medium",
  id,
}) => {
  const borderColors = {
    high: "border-red-200",
    medium: "border-amber-200",
    low: "border-blue-200",
    good: "border-green-200",
  };

  const iconColors = {
    high: "text-red-600",
    medium: "text-amber-600",
    low: "text-blue-600",
    good: "text-green-600",
  };

  return (
    <Card
      id={id}
      className={cn("transition-all hover:shadow-md", borderColors[severity])}
    >
      <CardHeader className="pb-3">
        <div className="flex items-center gap-3">
          <div
            className={cn("p-2 rounded-lg bg-opacity-10", iconColors[severity])}
          >
            {React.cloneElement(icon as React.ReactElement, {
              className: cn("h-5 w-5", iconColors[severity]),
            })}
          </div>
          <div>
            <CardTitle className="text-lg">{title}</CardTitle>
            <CardDescription className="text-sm">{description}</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
};
